import { rulebaseApi2Request } from "@/lib/rulebase-api2-client/client";
import { queryOptions } from "@tanstack/react-query";

export type CallSummaryPreference = { enabled: boolean };

export const callSummaryPreferenceQueryKey = [
  "session",
  "notifications",
  "call-summaries",
] as const;

export function getCallSummaryPreferenceQueryOptions() {
  return queryOptions({
    queryKey: callSummaryPreferenceQueryKey,
    queryFn: () =>
      rulebaseApi2Request<CallSummaryPreference>(
        "/session/notifications/call-summaries",
      ),
  });
}

export function updateCallSummaryPreference(enabled: boolean) {
  return rulebaseApi2Request<CallSummaryPreference>(
    "/session/notifications/call-summaries",
    {
      method: "PUT",
      body: JSON.stringify({ enabled }),
    },
  );
}
